module.exports = __webpack_public_path__ + "img/127.fc0907cf.png";